import { render, staticRenderFns } from "./ItemRac.vue?vue&type=template&id=b0671016&"
import script from "./ItemRac.vue?vue&type=script&lang=js&"
export * from "./ItemRac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports